export default {
  production: false,
  collabBackendApiUrl: process.env['COLLAB_BACKEND_URL'],
  url: process.env['TECH_BACKEND_URL'],
  appname: 'tech'
}


